import {Injectable} from "@angular/core";
import {ApiService} from "../../api/api.service";
import {Observable} from "rxjs";
import {IUserAssignDetail} from "../../../../pages/management/authorization-management/models/roles.interface";


@Injectable({
  providedIn: 'root'
})
export class UserActionsService {

  constructor(private readonly apiService: ApiService) {
  }

  getList() {
    return this.apiService.get<any>('user-permission-actions')
  }

  getById(id: string) {
    return this.apiService.get<any>(`user-permission-actions/${id}`)
  }

  create(data: IUserAssignDetail[]): Observable<any> {
    return this.apiService.post<any>('user-permission-actions/set', data)
  }

  update(data: IUserAssignDetail[]): Observable<any> {
    return this.apiService.patch<any>(`user-permission-actions/update`, data);
  }

  getUserRoleRelation(roleId: string, userId: string) {
    return this.apiService.get<any>(`user-permission-actions/${roleId}/${userId}`);
  }

  delete(id: string,): Observable<IUserAssignDetail> {
    return this.apiService.delete<IUserAssignDetail>(`user-permission-actions/delete/${id}`);
  }
}
